export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_mrpProductStockNo') || '成品入库单号',
    field: 'mrpProductStockNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_productStockInStatus') || '成品入库单状态',
    field: 'orderNo',
    minWidth: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {default: 'productStockInStatus'}
  },
  {
    title: that.$l('table_label_warehouseName') || '入库仓库名称',
    field: 'warehouseName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_workShopName') || '车间名称',
    field: 'workShopName',
    minWidth: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_stockInDate') || '入库日期',
    field: 'stockInDate',
    minWidth: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注',
    field: 'remark',
    minWidth: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    slots: {default: 'createInfo'}
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    slots: {default: 'modifyInfo'}
  },
]
